import { HttpHeaders } from '@angular/common/http';

export class CommonConfig {
  public static HTTP_OPTIONS = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  public static HTTP_OPTIONS_TEXT = {
    headers: new HttpHeaders({ 'Content-Type': 'text/plain' }),
  };
}
